import React, {useContext, useState} from 'react';
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Select, {SelectOption} from "@amzn/meridian/select";
import escapeRegExp from "lodash/escapeRegExp"
import {DraftContext} from "../../../draftSave/context/DraftSaveContext";
import {CONFIG_TYPE} from "../../../util/Constants";
import {getTestConfigKey} from "../../../util/Util";
import Icon from "@amzn/meridian/icon";
import trashTokens from "@amzn/meridian-tokens/base/icon/trash";

const DeleteAdtfSorterTestPackageModal = (props) => {

    const {formatMessage} = props.intl;
    const {open, setOpen, mac} = props;
    const {getDraftData, deleteInstance, deleteAll} = useContext(DraftContext);
    const [selectedScannables, setSelectedScannables] = useState("")
    const [searchQuery, setSearchQuery] = useState("")

    const onCloseModal = () => {
        setOpen(false);
        resetInputState();
    }

    const scannableKeyList = getDraftData({
        stateKey: CONFIG_TYPE.ADTF_SORTER_TEST_PACKAGE,
        subKey: mac
    }).map(({scannables}) => getTestConfigKey(scannables));
    const searchRegExp = new RegExp(escapeRegExp(searchQuery), "i")
    const matchedKeys = scannableKeyList.filter(
        option => !searchQuery || searchRegExp.test(option)
    )

    const onClickConfirm = () => {
        deleteData();
        setOpen(false)
        resetInputState();
    }

    function resetInputState() {
        setSelectedScannables("");
    }

    const deleteData = () => {
        deleteInstance({
            stateKey: CONFIG_TYPE.ADTF_SORTER_TEST_PACKAGE,
            subKey: mac,
            keyComparator: (instance) => getTestConfigKey(instance.scannables) === selectedScannables
        });
    }

    return (
        <Row>
            <Modal
                title={formatMessage({id: "config.deletetest"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                    <FormattedMessage id="modal.sortzonedelete"
                                      defaultMessage="Please select the scannable you would like to remove."/>
                </Text>
                <Column spacing={"medium"} spacingInset={"medium"}>
                    <Select
                        value={selectedScannables}
                        onChange={setSelectedScannables}
                        searchQuery={searchQuery}
                        onSearch={setSearchQuery}
                        placeholder={<FormattedMessage id="sortertestconfig.delete"
                                                       defaultMessage="Select test package to be deleted."/>}
                        width="100%">
                        {matchedKeys.map((scannable) =>
                            <SelectOption key={scannable} value={scannable} label={scannable}/>
                        )}
                        {!matchedKeys.length ? (
                            <Column alignmentVertical="center" spacing="100" spacingInset="100">
                                {scannableKeyList ? <Text alignment="center"> <FormattedMessage id="sortertestconfig.nomatch"
                                                                    defaultMessage="No matching test packages"/>  </Text>
                                    : <Text alignment="center"> <FormattedMessage id="sortertestconfig.notavailable"
                                                                  defaultMessage="No test packages available"/> </Text>}
                            </Column>) : null}
                    </Select>
                </Column>
                <ModalFooter>
                    <Row alignmentHorizontal="justify" widths="fit">
                        <Button
                            size="small"
                            className="redBtn"
                            onClick={() => {
                                deleteAll({stateKey: CONFIG_TYPE.ADTF_SORTER_TEST_PACKAGE, subKey: mac});
                                onCloseModal();
                            }}
                        >
                            <Icon tokens={trashTokens} />
                            <FormattedMessage id="modal.deleteAll" defaultMessage="Delete All"/>
                        </Button>
                        <Row alignmentHorizontal="right" widths="fit">
                            <Button type="secondary" size="small" onClick={onCloseModal}>
                                <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                            </Button>
                            <Button type="primary" size="small" onClick={onClickConfirm}>
                                <FormattedMessage id="modal.confirm" defaultMessage="Confirm"/>
                            </Button>
                        </Row>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(DeleteAdtfSorterTestPackageModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtfdevice/modal/DeleteAdtfSorterTestPackageModal.js